import { createContext, useContext, useMemo } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { fr } from "./fr";
import { en } from "./en";

const dicts = { fr, en };
const LangContext = createContext({ lang: "fr", t: fr });

export const LangProvider = ({ children }) => {
  const { lang } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const current = dicts[lang] ? lang : "fr";

  const value = useMemo(() => {
    const t = dicts[current];
    const p = (route = "") => `/${current}${route ? `/${route}` : ""}`;
    const switchTo = (target) => {
      if (!dicts[target]) return;
      localStorage.setItem("bt_lang", target);
      const rest = location.pathname.replace(/^\/(fr|en)/, "");
      navigate(`/${target}${rest}${location.search}`);
    };
    return { lang: current, t, p, switchTo };
  }, [current, location.pathname, location.search, navigate]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
export const getSavedLang = () => {
  const saved = localStorage.getItem("bt_lang");
  return saved === "en" || saved === "fr" ? saved : "fr";
};
